module.exports = __webpack_public_path__ + "static/media/yesterdayImage.1edbebd3.png";